module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[94]581.2eed773.woff2";